var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPower(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 22.573C13.764 22.573 12.132 21.897 10.904 20.67C9.677 19.442 9 17.81 9 16.073C9 14.336 9.677 12.704 10.904 11.476C11.295 11.085 11.927 11.085 12.318 11.476C12.709 11.867 12.709 12.499 12.318 12.89C11.468 13.741 11 14.871 11 16.073C11 17.275 11.468 18.406 12.318 19.256C13.168 20.106 14.297 20.573 15.5 20.573C16.703 20.573 17.832 20.105 18.682 19.256C19.533 18.406 20 17.276 20 16.073C20 14.87 19.532 13.74 18.682 12.89C18.291 12.499 18.291 11.867 18.682 11.476C19.073 11.085 19.705 11.085 20.096 11.476C21.323 12.705 22 14.337 22 16.073C22 17.809 21.323 19.442 20.096 20.67C18.868 21.897 17.236 22.573 15.5 22.573Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15C14.947 15 14.5 14.552 14.5 14V9C14.5 8.448 14.947 8 15.5 8C16.053 8 16.5 8.448 16.5 9V14C16.5 14.552 16.053 15 15.5 15Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.ee6fc3971e4825347f49351c3e133916.svg";
export { ForwardRef as ReactComponent };